import { Component, OnInit } from '@angular/core';
import { ScaffoldSidebarRef } from '@app/framework/sidebar/scaffold-sidebar.service';

@Component({
    selector: 'scaffold-view-panel',
    templateUrl: './view-panel.component.html',
    styleUrls: ['./view-panel.component.scss'],
    standalone: false
})
export class ViewPanelComponent implements OnInit {
  view_data: any = {};
  view: any;
  info: any;
  constructor(private sidebarRef: ScaffoldSidebarRef) {}

  ngOnInit(): void {}

  close() {
    this.sidebarRef.close();
  }
}
